import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import LoggedInLayout from './components/LoggedInLayout';
import { useAuth } from './context/AuthContext';

import LoginPage from './pages/LoginPage';
import KlinksListPage from './pages/KlinksListPage';
import KlinkDetailsPage from './pages/KlinkDetailsPage';

const App: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={
        isAuthenticated ? 
          <Navigate to="/klinks/list" replace /> : 
          <Navigate to="/login" replace />
      } />
      <Route path="/login" element={<LoginPage />} />

      {/* Protected Routes - These require authentication */}
      <Route
        path="/klinks/list"
        element={
          <ProtectedRoute>
            <LoggedInLayout>
              <KlinksListPage />
            </LoggedInLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/klinks/create"
        element={
          <ProtectedRoute>
            <LoggedInLayout>
              <KlinkDetailsPage />
            </LoggedInLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/klinks/:klink"
        element={
          <ProtectedRoute>
            <LoggedInLayout>
              <KlinkDetailsPage />
            </LoggedInLayout>
          </ProtectedRoute>
        }
      />

      {/* Catch-all for undefined routes */}
      <Route path="*" element={<div>404 - Page Not Found</div>} />
    </Routes>
  );
};

export default App;
